<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="'出售中('+countData.saleNumber+')'" name="first">
          <sale-on v-if="activeName == 'first'" :tabCurrent="1" @countUpdateNumStatus="countUpdateNumStatus"></sale-on>
        </el-tab-pane>
        <el-tab-pane :label="'仓库中 ('+countData.warehouseNumber+')'" name="second">
          <sale-on v-if="activeName == 'second'" :tabCurrent="0" @countUpdateNumStatus="countUpdateNumStatus"></sale-on>
        </el-tab-pane>
        <el-tab-pane :label="'已售罄 ('+countData.sellOutNumber+')'" name="third">
          <sale-on v-if="activeName == 'third'" :tabCurrent="2" @countUpdateNumStatus="countUpdateNumStatus"></sale-on>
        </el-tab-pane>
        <el-tab-pane :label="'警戒库存 ('+countData.alertNumber+')'" name="fourth">
          <sale-on v-if="activeName == 'fourth'" :tabCurrent="3" @countUpdateNumStatus="countUpdateNumStatus"></sale-on>
        </el-tab-pane>
        <el-tab-pane :label="'回收站 ('+countData.recycleNumber+')'" name="fiveth">
          <sale-on v-if="activeName == 'fiveth'" :tabCurrent="4" @countUpdateNumStatus="countUpdateNumStatus"></sale-on>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import SaleOn from './components/Sale.vue'
import { queryWebGoodsCount } from '@/api/goods'
export default {
  name: 'Goods',
  components: {
    SaleOn
  },
  data () {
    return {
      imgServer: this.$imgServer,
      fullscreenLoading: false,
      activeName: 'first',
      activeNum:1,
      countData:{
        warehouseNumber:0,
        saleNumber:0,
        sellOutNumber:0,
        alertNumber:0,
        recycleNumber:0
      }
    }
  },
  mounted () {
    this.countFun();
  },
  methods: {
    /* 切换选项卡操作 */
    handleClick (tab) {
    },
    countUpdateNumStatus(backData){
      this.countFun();
    },
    /* 统计数量 */
    countFun(){
      var that = this;
      queryWebGoodsCount({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.countData = data;
        }
      });
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/Goods.vue